'use client';

import { c as _c } from "react/compiler-runtime";
import { type RouterOutputs } from '@shared/all/domains/trpc';
import { X } from 'lucide-react';
import Avatar from './Avatar';
type UserTag = RouterOutputs['search']['getBatchSlugsAndUsernames']['users'][number];
type SpaceTag = RouterOutputs['search']['getBatchSlugsAndUsernames']['spaces'][number];
type FactiiiTag = RouterOutputs['search']['getBatchSlugsAndUsernames']['factiiis'][number];
export type Tag = UserTag | SpaceTag | FactiiiTag;
type Props = {
  tags: Tag[];
  onRemove: (tag: Tag) => void;
  showContainer?: boolean;
};
const TagPills = t0 => {
  const $ = _c(11);
  const {
    tags,
    onRemove,
    showContainer: t1
  } = t0;
  const showContainer = t1 === undefined ? true : t1;
  if (tags.length === 0) {
    return null;
  }
  let t2;
  if ($[0] !== onRemove) {
    t2 = tag => {
      const tagName = tag.type === "user" ? tag.username : tag.slug;
      const tagPrefix = tag.type === "user" ? "@" : tag.type === "space" ? "s/" : "f/";
      return <div key={tag.id} className="group inline-flex shrink-0 items-center gap-2 rounded-lg bg-background-secondary px-3 py-2 text-sm font-emphasis text-textPrimary transition-all duration-200">{tag.type === "user" && <Avatar avatarKey={tag.avatarKey} robohash={tag.robohash} isBot={tag.tag === "BOT"} userId={tag.id} size={20} />}{tag.type === "space" && <Avatar spaceAvatarKey={tag.avatarKey} size={20} />}{tag.type === "factiii" && <Avatar factiiiAvatarKey={tag.avatarKey} factiiiId={tag.id} size={20} />}<div className="max-w-[150px] select-none truncate">{tagPrefix}{tagName}</div><button type="button" className="ml-1 flex size-5 shrink-0 items-center justify-center rounded-full bg-textSecondary/20 transition-all duration-200 hover:scale-110 hover:bg-textSecondary/30" onClick={() => onRemove(tag)} aria-label={`Remove ${tagName}`}><X height={12} width={12} className="stroke-[2.5]" /></button></div>;
    };
    $[0] = onRemove;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const renderTag = t2;
  let t3;
  if ($[2] !== renderTag || $[3] !== tags) {
    let t4;
    if ($[5] !== renderTag) {
      t4 = tag_0 => renderTag(tag_0);
      $[5] = renderTag;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = tags.map(t4);
    $[2] = renderTag;
    $[3] = tags;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="flex flex-wrap items-center gap-2">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const content = t4;
  if (showContainer) {
    let t5;
    if ($[9] !== content) {
      t5 = <div className="rounded-lg border border-ds-border-standard bg-gradient-to-r from-background-secondary to-background-light p-4 shadow-md">{content}</div>;
      $[9] = content;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  return content;
};
export default TagPills;